import { AnimatePresence } from 'framer-motion';
import { FC, useState } from 'react';
import styled from 'styled-components';

import { ReactComponent as CommentIcon } from '@/assets/icons/comment.svg';
import Button from '@/components/Button';
import SelectedImagesBadge from '@/pages/CoverImagesGenerator/components/SelectedImagesBadge';
import { CoverImagesImageStatus } from '@/utils/enums';

import CommentModal from './CommentModal';

const Box = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
`;

const Actions = styled.div`
  gap: 16px;
  display: flex;
`;

const StyledButton = styled(Button)`
  height: 38px;
  font-size: 14px;
  padding: 0 24px;
`;

const CommentButton = styled(StyledButton)`
  gap: 8px;
  padding: 0 12px;
`;

interface Props {
  comment?: string;
  selectedImages: number[];
  imagesCount: number;
  setSelectedImages: React.Dispatch<React.SetStateAction<number[]>>;
  onSelectAll: (value: React.SetStateAction<number[]>) => void;
  status: CoverImagesImageStatus;
}

const SelectionActions: FC<Props> = ({
  selectedImages,
  imagesCount,
  setSelectedImages,
  onSelectAll,
  status,
  comment,
}) => {
  const [showCommentModal, setShowCommentModal] = useState(false);

  return (
    <Box>
      <Actions>
        {status === CoverImagesImageStatus.PENDING && (
          <CommentButton
            color="secondary"
            disabled={selectedImages.length === imagesCount}
            onClick={() => setShowCommentModal(true)}
          >
            <CommentIcon />
            General Comment
          </CommentButton>
        )}
      </Actions>
      <Actions>
        <StyledButton
          color="colorized"
          disabled={selectedImages.length === imagesCount}
          onClick={onSelectAll}
        >
          Select All
        </StyledButton>
        <StyledButton
          color="secondary"
          disabled={!selectedImages.length}
          onClick={() => setSelectedImages([])}
        >
          Unselect All
        </StyledButton>
        <SelectedImagesBadge
          selectedCount={selectedImages.length}
          imagesCount={imagesCount}
        />
      </Actions>
      <AnimatePresence>
        {showCommentModal && (
          <CommentModal
            onClose={() => setShowCommentModal(false)}
            setSelectedImages={setSelectedImages}
            comment={comment}
          />
        )}
      </AnimatePresence>
    </Box>
  );
};

export default SelectionActions;
